import { render, staticRenderFns } from "./AvatarEditor.vue?vue&type=template&id=620ae566&scoped=true&"
import script from "./AvatarEditor.vue?vue&type=script&lang=ts&"
export * from "./AvatarEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarEditor.vue?vue&type=style&index=0&id=620ae566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ae566",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
